<template>
  <div class="order_box">
    <el-container class="order_overall">
      <el-header class="order_top">
        <el-row class="order_label">
          <el-col :class="print1 === 0 ? 'order_each' : 'actives'">
            <div class="eventStatus" @click="printEvent(1)">全部</div>
          </el-col>
          <el-col :class="print2 === 0 ? 'order_each' : 'actives'">
            <div class="eventStatus" @click="printEvent(2)">报价</div>
          </el-col>
          <el-col :class="print3 === 0 ? 'order_each' : 'actives'">
            <div class="eventStatus" @click="printEvent(3)">进行中</div>
          </el-col>
          <el-col :class="print4 === 0 ? 'order_each' : 'actives'">
            <div class="eventStatus" @click="printEvent(4)">已完成</div>
          </el-col>
          <el-col :class="print5 === 0 ? 'order_each' : 'actives'">
            <div class="eventStatus" @click="printEvent(5)">已取消</div>
          </el-col>
        </el-row>
        <!-- 表单 -->
        <el-row style="padding-top: 10px;">
          <el-col
            :span="2"
            style="text-align: left;font-size: 15px; padding-left:30px; width:95px; padding-top: 8px;"
          >起运港：</el-col>
          <el-col :span="8" style="width:370px;">
            <el-select
              class="order_qi"
              v-model="startPortCode"
              filterable
              clearable
              remote
              default-first-option
              placeholder="请输入起运港"
              :remote-method="remoteStart"
              @focus="getFocus('start')"
              @change="getHandeleStart"
            >
              <el-option
                v-for="(item,index) in startPortList"
                :key="index"
                :label="item.portEn"
                :value="item.portCode"
              >
                <span style="float: left;font-size: 12px;">{{ item.portEn }}</span>
                <span style="float: right;font-size: 12px;margin-left: 10px;">{{ item.portCn }}</span>
              </el-option>
            </el-select>
          </el-col>
          <el-col
            :span="3"
            style="text-align: left;font-size: 15px; padding-left:30px; width:100px; padding-top: 8px;"
          >目的港：</el-col>

          <el-col :span="9" style="width:370px;">
            <el-select
              class="order_md"
              v-model="reachPortCode"
              filterable
              clearable
              remote
              default-first-option
              placeholder="请输入目的港"
              :remote-method="remoteReach"
              @focus="getFocus('reach')"
              @change="getHandeleReach"
            >
              <el-option
                v-for="(item,index) in reachPortList"
                :key="index"
                :label="item.portEn"
                :value="item.portCode"
              >
                <span style="float: left;font-size: 12px;">{{ item.portEn }}</span>
                <span style="float: right;font-size: 12px;margin-left: 10px;">{{ item.portCn }}</span>
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-form :inline="true" :model="orderForm" ref="orderForm" class="order_search">
          <el-form-item label="订单编号" prop="number">
            <el-input v-model="orderForm.number" placeholder="请输入订单"></el-input>
          </el-form-item>
          <el-form-item label="服务需求" prop="demand">
            <el-select v-model="orderForm.demand" multiple placeholder="全部">
              <el-option label="海运" value="10"></el-option>
              <el-option label="报关" value="20"></el-option>
              <el-option label="拖车" value="30"></el-option>
              <el-option label="内装" value="40"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="float: right;">
            <el-button type="primary" class="order-inquire" @click="submitForm(orderForm)">查询</el-button>
            <el-button class="order-reset" @click="resetForm('orderForm')">重置</el-button>
          </el-form-item>
          <ul class="fye">
            <li class="ye ye1">订单编号</li>
            <li class="ye ye2">订单信息</li>
            <li class="ye ye7">提单号</li>
            <li class="ye ye3">服务需求</li>
            <li class="ye ye4">订单状态</li>
            <li class="ye ye5">下单人</li>
            <li class="ye ye6">操作</li>
          </ul>
        </el-form>
      </el-header>
      <!-- 内容 -->
      <el-main class="order_content" :class="DataForm.length == 0 ? 'order_content2':''">
        <div v-show="DataForm.length == 0" v-loading="loading">
          <div class="box-no-hezi">
            <div class="box-no-data"></div>
            <div class="box-no-font">您还未通过平台下单</div>
          </div>
        </div>
        <ul class="orr_content">
          <li class="box-lits" v-for="(item,index) in DataForm">
            <div class="ws1">{{item.orderNo}}</div>
            <div class="ws2">
              <span style="display: block;">{{item.originStation}}-{{item.destStation}}</span>
              <span style="display: block;">ETD:{{ item.estimatedTimeDelivery }} T/T:{{item.voyage}}</span>
              <span style="display: block;">{{ item.containerQuantity }}</span>
            </div>
            <div class="ws7">
              <div style="width: 170px;height: 88px;">{{item.mawbNo}}</div>
            </div>
            <div class="ws3">
              <i class="icon_1"></i>
              <span class="character">海运</span>
              <i :class="item.additionService2 == 10 ? 'icon_2':'icon_2_2'"></i>
              <span class="character">报关</span>
              <i :class="item.additionService1 == 10 ? 'icon_3':'icon_3_2'"></i>
              <span class="character">拖车</span>
              <i :class="item.additionService3 == 10 ? 'icon_4':'icon_4_2'"></i>
              <span class="character">内装</span>
            </div>
            <div class="ws4">
              <i v-if="item.orderStatus > 19 && item.orderStatus < 33 " class="icon_5"></i>
              <i v-if="item.orderStatus > 32 && item.orderStatus < 71" class="icon_5_2"></i>
              <i v-if="item.orderStatus == 80 " class="icon_5_3"></i>
              <i v-if="item.orderStatus == 90 " class="icon_5_4"></i>
            </div>
            <div class="ws5">{{item.creatorOrder}}</div>
            <div class="ws6">
              <el-button
                disabled
                class="order_ws6_button"
                size="mini"
                @click="handleEdit(item)"
              >查看详情</el-button>
            </div>
          </li>
        </ul>
      </el-main>
      <!-- 分页 -->
      <el-pagination
        class="paging"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="PageSize"
        layout=" prev, pager, next"
        :total="totalCount"
        background
      ></el-pagination>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      aggregate: "", //全部
      startPort: "", //起运港
      reachPort: "", //目的港
      startPortCode: "", //起运港五字码
      reachPortCode: "", //目的港五字码
      loading: false,
      status: true, //订单数据
      currentPage: 1, //默认开始页面
      totalCount: 1, //总条数
      PageSize: 8, //每页的数据条数
      print1: 1,
      print2: 0,
      print3: 0,
      print4: 0,
      print5: 0,
      orderForm: {
        number: "", //编号
        demand: "", //服务需求
        order: "" //订单状态
      },
      startPortList: [], //起运港
      reachPortList: [], //目的港数据
      DataForm: [
        {
          additionService1: "10",
          additionService2: "10",
          creatorOrder: "蔡小林",
          destStation: "洛杉矶",
          estimatedTimeDelivery: "20-09-01",
          freightTerm: "50",
          orderNo: "T2020082800001",
          orderStatus: "30",
          originStation: "上海",
          salesPerson: "乔琳",
          shippingCompanyName: "OOCL",
          specialRequirements: "无",
          vesselOrVoyageNo: "OOCL LONDON/078E",
          voyage: "17"
        },
        {
          additionService1: "10",
          additionService2: "10",
          creatorOrder: "艾瑞斯",
          destStation: "东京",
          estimatedTimeDelivery: "20-08-15",
          freightTerm: "50",
          orderNo: "T2020081100002",
          orderStatus: "30",
          originStation: "上海",
          remark: "",
          salesPerson: "周鹏",
          shippingCompanyName: "SNK",
          specialRequirements: "无",
          vesselOrVoyageNo: "AS RICCARDA/2003E",
          voyage: "5"
        },
        {
          additionService1: "10",
          additionService2: "10",
          creatorOrder: "艾瑞斯",
          destStation: "东京",
          estimatedTimeDelivery: "20-08-15",
          freightTerm: "50",
          orderNo: "T2020081100001",
          orderStatus: "30",
          originStation: "上海",
          remark: "",
          salesPerson: "周鹏",
          shippingCompanyName: "SNK",
          specialRequirements: "无",
          vesselOrVoyageNo: "AS RICCARDA/2003E",
          voyage: "5"
        },
        {
          additionService1: "10",
          additionService2: "10",
          creatorOrder: "蔡小林",
          destStation: "横滨",
          estimatedTimeDelivery: "20-07-04",
          freightTerm: "50",
          orderNo: "T2020063000103",
          orderStatus: "40",
          originStation: "上海",
          remark: "",
          salesPerson: "乔琳",
          shippingCompanyName: "DJS",
          specialRequirements: "无",
          vesselOrVoyageNo: "SONG YUN HE/2027E",
          voyage: "5"
        }
      ]
    };
  },
  mounted() {
    // this.orderMg();
  },
  methods: {
    printEvent(val) {
      this.currentPage = 1;
      if (val === 1) {
        this.print1 = 1;
        this.print2 = 0;
        this.print3 = 0;
        this.print4 = 0;
        this.print5 = 0;
        this.orderForm.order = "";
        this.orderMg();
        this.resetForm();
      } else if (val === 2) {
        this.print2 = 1;
        this.print1 = 0;
        this.print3 = 0;
        this.print4 = 0;
        this.print5 = 0;
        this.orderForm.order = "1";
        this.orderMg();
        this.resetForm();
      } else if (val === 3) {
        this.print3 = 1;
        this.print1 = 0;
        this.print2 = 0;
        this.print4 = 0;
        this.print5 = 0;
        this.orderForm.order = "2";
        this.orderMg();
        this.resetForm();
      } else if (val === 4) {
        this.print4 = 1;
        this.print1 = 0;
        this.print2 = 0;
        this.print3 = 0;
        this.print5 = 0;
        this.orderForm.order = "3";
        this.orderMg();
        this.resetForm();
      } else if (val === 5) {
        this.print5 = 1;
        this.print2 = 0;
        this.print3 = 0;
        this.print4 = 0;
        this.print1 = 0;
        this.orderForm.order = "4";
        this.orderMg();
        this.resetForm();
      }
    },
    handleCurrentChange(val) {
      // 修改了当前页
      this.currentPage = val;
      this.orderMg(this.order);
    },
    submitForm(val) {
      // console.log(val);
      // if (val.number) {
      //   this.loading = true;
      //   let that = this;
      //   let len = JSON.parse(sessionStorage.getItem("testKeys"));
      //   let lenww = JSON.parse(localStorage.getItem("userInfo"));
      //   that
      //     .axios({
      //       method: "get",
      //       url:
      //         that.apiUrl +
      //         "/bnwl_oms_business/api/omsOrderOrderInformation/queryOne",
      //       timeout: 60000,
      //       responseType: "json",
      //       params: {
      //         roleCode: len.roleCode,
      //         creatorOrderCode: lenww.username,
      //         customerCode: lenww.customerCode,
      //         orderNo: val.number
      //       }
      //     })
      //     .then(res => {
      //       this.loading = false;
      //       this.DataForm = res.data.data;
      //       // this.totalCount = res.data.recordsTotal;
      //       console.log(this.DataForm);
      //     });
      // } else {
      //   this.currentPage = 1;
      //   this.orderMg();
      // }
    },
    //监听起运港输入框的值
    remoteStart(value) {
      this.getPortData(value, "start");
    },
    //监听目的港输入框的值
    remoteReach(value) {
      this.getPortData(value, "reach");
    },
    //获取起运港和目的港港口数据
    async getPortData(val, type) {
      let that = this;
      let params = {};
      params.strKey = val;
      let response = await this.apiService
        .get("/cimcilp-common-service/mdPort/getMdPortInfo", { params })
        .then(res => {
          switch (type) {
            case "start":
              that.startPortList = res.data.data.records;
              break;
            case "reach":
              that.reachPortList = res.data.data.records;
              break;
          }
        });
    },
    //起运港选中值发生变化时触发
    getHandeleStart(value) {
      if (this.startPortList) {
        var objItem = this.startPortList.find(item => {
          return item.portCode === value;
        });
      }
      if (typeof objItem == "object") {
        this.startPort = objItem.portEn;
        this.originPortCode = objItem.portCode;
      } else {
        this.startPort = "";
      }
    },
    //目的港选中值发生变化时触发
    getHandeleReach(value) {
      if (this.reachPortList) {
        var objItem = this.reachPortList.find(item => {
          return item.portCode === value;
        });
      }

      if (typeof objItem == "object") {
        this.reachPort = objItem.portEn;
        this.destinationPortCode = objItem.portCode;
      } else {
        this.reachPort = "";
      }
    },
    //起运港和目的港获取焦点事件
    getFocus(portType) {
      switch (portType) {
        case "start":
          this.getPortData(this.startPort, portType);
          break;
        case "reach":
          this.getPortData(this.reachPort, portType);
          break;
      }
    },
    resetForm() {
      // this.$refs.orderForm.resetFields();
      // this.startPortCode = "";
      // this.reachPortCode = "";
    },
    handleEdit(val) {
      sessionStorage.setItem("number", JSON.stringify(val.orderNo));
      this.$router.push({
        name: "OrderTwo",
        params: {
          orderNo: val.orderNo
        }
      });
    },
    // 订单基本信息
    orderMg(val) {
      // this.loading = true;
      // let that = this;
      // let len = JSON.parse(sessionStorage.getItem("testKeys"));
      // let lenww = JSON.parse(localStorage.getItem("userInfo"));
      // that
      //   .axios({
      //     method: "post",
      //     url:
      //       that.apiUrl +
      //       "/bnwl_oms_business/api/omsOrderOrderInformation/query",
      //     timeout: 60000,
      //     responseType: "json",
      //     data: {
      //       roleCode: len.roleCode,
      //       customerCode: lenww.customerCode,
      //       originStationCode: this.startPortCode,
      //       destStationCode: this.reachPortCode,
      //       orderStatus: this.orderForm.order,
      //       pageNumber: this.currentPage,
      //       demand: this.orderForm.demand,
      //       creatorOrderCode: lenww.username
      //     }
      //   })
      //   .then(res => {
      //     this.loading = false;
      //     if (res.data.message == "成功") {
      //       this.DataForm = res.data.data;
      //       this.totalCount = res.data.recordsTotal;
      //       this.aggregate = res.data.recordsTotal;
      //     } else {
      //       return false;
      //     }
      //   });
    }
  },

  created() {
    // this.panduan();
  }
};
</script>

<style>
ul li {
  list-style: none;
  padding: 0px;
  margin: 0px;
}
i {
  font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/steward/Order.vue